import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=2c1c6b78&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=2c1c6b78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c6b78",
  null
  
)

export default component.exports